<div class="container">
  <div class="crew-header">
    <mat-form-field appearance="outline">
      <mat-label>From Date - To Date</mat-label>
      <mat-date-range-input [rangePicker]="picker" [max]="currDate">
        <input matStartDate matInput [(ngModel)]="fromDate" [disabled]="!loaded" placeholder="From date" />
        <input matEndDate matInput [(ngModel)]="toDate" [disabled]="!loaded" (ngModelChange)="onDateChanged()"
          placeholder="To date" />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <button mat-flat-button class="remove" [hidden]=" ( toDate == null ) || !loaded" (click)="reset()">
      <mat-icon>refresh</mat-icon>
    </button>
    <button mat-raised-button color="primary" class="button ml-auto" [disabled]="activityDate.length == 0 || !loaded"
      (click)="onExport()">
      <mat-icon>sim_card_download</mat-icon>
      Export
    </button>
  </div>
  <div *ngIf="loaded; else loading" id="analytic-charts">
    <div class="row card_align">
      <mat-card class="card">
        <div class="card_block">
          <div class="card_title">
            <p>Logs Count</p>
            <h4>{{logs()}}</h4>
          </div>
          <button class="icon" mat-fab color="primary">
            <mat-icon>list_alt</mat-icon>
          </button>
        </div>
        <div class="progressbar_block">
          <mat-progress-bar mode="determinate" value="{{logFilter/logCount * 100}}"></mat-progress-bar>
        </div>
        <div class="card_block">
          <div class="card_footerLeft">
            <p>Number of logs ( % )</p>
          </div>
          <div class="card_footerRight">
            <p>{{(logFilter/logCount * 100).toFixed(2)}} %</p>
          </div>
        </div>
      </mat-card>
      <mat-card class="card">
        <div class="card_block">
          <div class="card_title">
            <p>Unique Users Count</p>
            <h4>{{usersChart.length ? usersChart.length : 0}}</h4>
          </div>
          <button class="icon" mat-fab color="primary">
            <mat-icon>person</mat-icon>
          </button>
        </div>
        <div class="progressbar_block">
          <mat-progress-bar mode="determinate" value="{{userFilter/userCount * 100}}"></mat-progress-bar>
        </div>
        <div class="card_block">
          <div class="card_footerLeft">
            <p>Unique Users ( % )</p>
          </div>
          <div class="card_footerRight">
            <p>{{(userFilter/userCount * 100).toFixed(2)}} %</p>
          </div>
        </div>
      </mat-card>
      <mat-card class="card">
        <div class="card_block">
          <div class="card_title">
            <p>Unique Clients Count</p>
            <h4>{{clientChart.length ? clientChart.length : 0}}</h4>
          </div>
          <button class="icon" mat-fab color="primary">
            <mat-icon>people</mat-icon>
          </button>
        </div>
        <div class="progressbar_block">
          <mat-progress-bar mode="determinate" value="{{clientFilter/clientCount * 100}}"></mat-progress-bar>
        </div>
        <div class="card_block">
          <div class="card_footerLeft">
            <p>Unique Clients ( % )</p>
          </div>
          <div class="card_footerRight">
            <p>{{(clientFilter/clientCount * 100).toFixed(2)}} %</p>
          </div>
        </div>
      </mat-card>
    </div>
    <div class="row" *ngIf="dateChart.length; else noData">
      <highcharts-chart #chart [Highcharts]="highcharts" [options]="chartOptions" (chartInstance)="saveInstance($event)"
        [(update)]="updateFlag" style="width: 100%; height: 100%; ">
      </highcharts-chart>
    </div>
    <div class="row">
      <highcharts-chart *ngIf="usersChart.length" #chart [Highcharts]="highcharts" [options]="chartOptions1"
        (chartInstance)="saveInstance1($event)" [(update)]="updateFlag" class="twocharts">
      </highcharts-chart>
      <highcharts-chart *ngIf="clientChart.length" #chart [Highcharts]="highcharts" [options]="chartOptions2"
        (chartInstance)="saveInstance2($event)" [(update)]="updateFlag1" class="twocharts">
      </highcharts-chart>
    </div>
    <div class="row" [hidden]="!categoryChart.length">
      <highcharts-chart #chart [Highcharts]="highcharts" [options]="chartOptions3"
        (chartInstance)="saveInstance3($event)" [(update)]="updateFlag2" [(oneToOne)]="oneToOne"
        style="width: 100%; height: 100%; ">
      </highcharts-chart>
    </div>
    <ng-template #noData>
      <div class="tabel-con">
        <img src="../../../../assets/noData.svg" width="170" alt="">
        <span class="mt-4"> No Activity Found</span>
      </div>
    </ng-template>
  </div>
</div>
<ng-template #loading>
  <div class="center loading">
    <span class="d">.</span><span class="d d-2">.</span><span class="d d-3">.</span>
  </div>
</ng-template>
